import axios from 'axios'
import {Message, Loading, MessageBox} from 'element-ui'
import router from '../router'
import store from '../vuex'
import jsCookie from 'js-cookie'

var instance = axios.create({timeout: 1000 * 60})
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
var loadingInstance = null
// 全局节流：登录超时弹框在10秒内只弹一次
let lastLoginTimeoutAlertAtMs = 0
const LOGIN_TIMEOUT_ALERT_COOLDOWN_MS = 5000

// let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// let cancelToken = axios.CancelToken
// let removeRepeatUrl = (ever) => {
//   for (let p in pending) {
//     if (pending[p].u === ever.url + '&' + ever.method) { // 当前请求在数组中存在时执行函数体
//       pending[p].f() // 执行取消操作
//       pending.splice(p, 1) // 把这条记录从数组中移除
//     }
//   }
// }

instance.interceptors.request.use(config => {
  // 登录流程控制中，根据本地是否存在token判断用户的登录情况
  // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
  // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
  // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。

  // 在一个ajax发送前执行一下取消操作
  // removeRepeatUrl(config)
  // config.cancelToken = new cancelToken ((c) => {
  //   // 自定义唯一标识
  //   pending.push({ u: config.url + '&' + config.method, f: c })
  // })

  const token = jsCookie.get(`token_${window.location.port}`)
  token && (config.headers.certificate = token)
  //  if (!config.headers['Content-Type']) {//为json类型参数统一增加asp参数(ps:尝试了各种方法去区分两种请求头都没用。。。为‘application/x-www-form-urlencoded’时Content-Type为application/json；为‘application/json’时Content-Type为undefined？？？什么鬼？！！)
  //  let data = config.data
  //  let user = JSON.parse(localStorage.getItem('user'))
  //  data.asp = user.asp
  //  data.userId = user.userId
  //  config.data = data
  // }
  loadingInstance = Loading.service({
    fullscreen: true,
    text: '正在加载',
    background: 'rgba(0, 0, 0, 0)'
  })
  return config
},
error => Promise.error(error)
)

const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 登录超时，跳转登录页
    case 401:
      {
        const now = Date.now()
        if (now - lastLoginTimeoutAlertAtMs > LOGIN_TIMEOUT_ALERT_COOLDOWN_MS) {
          lastLoginTimeoutAlertAtMs = now
          MessageBox.alert('关闭提示后重新登录', '登录超时', {
            confirmButtonText: '确定',
            callback: action => {
              router.push({path: '/login'})
            }
          })
        }else{
          router.push({path: '/login'})
        }
      }
      break
    case 503:
      Message({
        message: '服务器正在更新数据，请稍后重试',
        center: true
      })
      break
      // 404请求不存在
    case 404:
      // tip('请求的资源不存在');
      break
    default:
      console.log(other)
  }
}

instance.interceptors.response.use(res => { // 请求成功
  loadingInstance && loadingInstance.close()
  if (res.config.responseType === 'blob' || res.config.responseType === 'arraybuffer') {
    return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
  }
  if (res.data && res.data.code != '0000') {
    Message({
      message: res.data.message,
      center: true,
      type: 'warning'
    })
  }
  return res.status === 200 ? Promise.resolve(res) : Promise.reject(res)
},
error => { // 请求失败
  loadingInstance && loadingInstance.close()
  const { response } = error
  if (response) {
    // 请求已发出，但是不在2xx的范围
    errorHandle(response.status, response.data.message)
    return Promise.reject(response)
  } else {
    Message({
      message: '网络异常，请稍后重新尝试',
      center: true,
      type: 'warning'
    })
    // 处理断网的情况
    // eg:请求超时或断网时，更新state的network状态
    // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
    // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    // store.commit('changeNetwork', false);
  }
}
)

export default instance



// WEBPACK FOOTER //
// ./src/request/http.js